// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Status_status__0iwKV {
  padding: 4px 12px;
  border-radius: 4px;
  font-weight: 500;
  font-size: 16px;
  line-height: 28px;
  color: #fff;
}
.Status_status__0iwKV.Status_success__UKCxf {
  background: #58b441;
}
.Status_status__0iwKV.Status_warning__dLmik {
  background: #e78d3d;
}
.Status_status__0iwKV.Status_error__\\+vMG- {
  background: #bd454a;
}
.Status_status__0iwKV.Status_adhesionActive__DaiLo {
  background: #58b441;
}
.Status_status__0iwKV.Status_adhesionUnpaid__Q0dLk {
  background: #fbd298;
  color: #b94402;
}
.Status_status__0iwKV.Status_adhesionInactive__aBU3X {
  background: #d2d2d7;
  color: #555;
}
.Status_status__0iwKV.Status_adhesionSigned__GWeeu {
  background: #d8d8ff;
  color: #00007a;
}`, "",{"version":3,"sources":["webpack://./src/components/common/Status/Status.module.scss","webpack://./src/styles/colors.scss"],"names":[],"mappings":"AAGA;EACE,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,WAAA;AAIF;AAFE;EACE,mBCOO;ADHX;AADE;EACE,mBCQS;ADLb;AAAE;EACE,mBCUM;ADRV;AACE;EACE,mBCLO;ADMX;AAEE;EACE,mBCLS;EDMT,cCJS;ADIb;AAGE;EACE,mBAAA;EACA,WAAA;AADJ;AAIE;EACE,mBCrCO;EDsCP,cChCO;AD8BX","sourcesContent":["@use 'styles/colors.scss';\n@use 'styles/sizes.scss';\n\n.status {\n  padding: 4px 12px;\n  border-radius: 4px;\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 28px;\n  color: #fff;\n\n  &.success {\n    background: colors.$success5;\n  }\n\n  &.warning {\n    background: colors.$attention5;\n  }\n\n  &.error {\n    background: colors.$danger5;\n  }\n\n  &.adhesionActive {\n    background: colors.$success5;\n  }\n\n  &.adhesionUnpaid {\n    background: colors.$attention3;\n    color: colors.$attention7;\n  }\n\n  &.adhesionInactive {\n    background: #d2d2d7;\n    color: #555;\n  }\n\n  &.adhesionSigned {\n    background: colors.$primary2;\n    color: colors.$primary8;\n  }\n}\n","$primary1: #f5f5ff;\n$primary2: #d8d8ff;\n$primary3: #8686ff;\n$primary4: #4343ff;\n$primary5: #1414ff;\n$primary6: #0000c9;\n$primary7: #000093;\n$primary8: #00007a;\n$primary9: #000054;\n$primary10: #00003a;\n$primary11: #000078;\n$blueLogo: #000093;\n\n$neutral1: #fcfcfd;\n$neutral2: #f9f9fa;\n$neutral4: #e0e0e3;\n$neutral8: #838390;\n\n$success1: #f4fced;\n$success5: #58b441;\n$success6: #126f0e;\n\n$attention1: #fef9f0;\n$attention3: #fbd298;\n$attention5: #e78d3d;\n$attention7: #b94402;\n\n$danger1: #fdf1ed;\n$danger2: #f9d9cf;\n$danger3: #f4ada1;\n$danger5: #bd454a;\n$danger6: #911727;\n$danger7: #7c1028;\n\n\n$colabelNeutralLight: #F9F9FA;\n$colabelNeutralMid: #C3C3C9;\n$colabelNeutralDark: #121217;\n\n:export {\n    colabelNeutralLight: $colabelNeutralLight;\n    colabelNeutralMid: $colabelNeutralMid;\n    colabelNeutralDark: $colabelNeutralDark;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"colabelNeutralLight": `#F9F9FA`,
	"colabelNeutralMid": `#C3C3C9`,
	"colabelNeutralDark": `#121217`,
	"status": `Status_status__0iwKV`,
	"success": `Status_success__UKCxf`,
	"warning": `Status_warning__dLmik`,
	"error": `Status_error__+vMG-`,
	"adhesionActive": `Status_adhesionActive__DaiLo`,
	"adhesionUnpaid": `Status_adhesionUnpaid__Q0dLk`,
	"adhesionInactive": `Status_adhesionInactive__aBU3X`,
	"adhesionSigned": `Status_adhesionSigned__GWeeu`
};
export default ___CSS_LOADER_EXPORT___;
